import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Eye, EyeOff, Trash2, Heart } from "lucide-react";

// Admin moderation for the Community Wall: hide/unhide or permanently delete posts.
export default function AdminCommunity() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/community").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const hide = async (m) => {
    await api.post(`/admin/community/${m.id}/hide`);
    toast.success(m.hidden ? "Post is visible again" : "Post hidden from the wall");
    load();
  };
  const del = async (m) => {
    if (!window.confirm("Delete this post permanently?")) return;
    await api.delete(`/admin/community/${m.id}`);
    toast.success("Post deleted");
    load();
  };

  if (!items) return null;
  return (
    <div data-testid="admin-community">
      <p className="text-zinc-500 text-sm font-light mb-4">Hidden posts stay saved but no longer appear on the Community Wall or homepage.</p>
      {items.length === 0 && <p className="text-zinc-600 text-sm" data-testid="admin-community-empty">No community posts yet.</p>}
      <div className="space-y-3">
        {items.map((m) => (
          <div key={m.id} data-testid={`admin-post-${m.id}`} className={`glass-card p-5 flex items-start justify-between gap-4 ${m.hidden ? "opacity-50" : ""}`}>
            <div className="min-w-0">
              <p className="text-zinc-200 font-light break-words">"{m.message}"</p>
              <div className="text-xs text-zinc-600 mt-2 flex items-center gap-3">
                <span>— {m.alias}</span>
                <span className="flex items-center gap-1"><Heart className="w-3 h-3" /> {m.likes}</span>
                <span>{new Date(m.created_at).toLocaleDateString()}</span>
                {m.hidden && <span className="text-amber-400" data-testid={`admin-post-hidden-${m.id}`}>Hidden</span>}
              </div>
            </div>
            <div className="flex gap-3 shrink-0">
              <button onClick={() => hide(m)} title={m.hidden ? "Unhide" : "Hide"} data-testid={`admin-post-hide-${m.id}`} className="text-zinc-500 hover:text-white transition-colors">
                {m.hidden ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}
              </button>
              <button onClick={() => del(m)} title="Delete" data-testid={`admin-post-delete-${m.id}`} className="text-zinc-500 hover:text-red-400 transition-colors"><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
